import {LOGOUT_RESET} from '../constants'
import {saveToLocalStorage} from "../../utils/storage";

export const logoutAction = () => async dispatch => {

    dispatch({ type: LOGOUT_RESET, payload: {} })

    await saveToLocalStorage('user', null, -1)

}